import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { CatalogosService } from 'src/app/services/catalogos.service';

@Component({
  selector: 'app-flujo-efectivo',
  templateUrl: './flujo-efectivo.component.html',
  styleUrls: ['./flujo-efectivo.component.scss']
})
export class FlujoEfectivoComponent implements OnInit {
  dineroEfectivo = 0;
  dineroCuentaBanco = 0;
  movimientos:any;
  movimientosNuevos=[];
  respuestaGet:any;
  respuestaAgregar:any;
  data:any;
  formulario;

  constructor(private _pagos:CatalogosService, private modalService:NgbModal, private iziToast:Ng2IzitoastService) { }

  ngOnInit(): void {
    this.getFlujoEfectivo();
    this.formulario = {
      'cantidad':1,
      'tipo':"",
      'concepto':"",
      'iva':"",
      'total':"0",
      'proveedor':"",
      'forma_pago':1,
      'estatus':1,
    }
  }

  getFlujoEfectivo(){
    this._pagos.getFlujoEfectivo().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.movimientos = this.respuestaGet.content;
         
          var totalFinal = 0;
          this.dineroEfectivo = this.respuestaGet.utilidad;
          for(var i = 0; i < this.movimientos.length; i++){
            if(this.movimientos[i].tipo == 0){
              totalFinal-=this.movimientos[i].monto
              // this.dineroEfectivo-=this.movimientos[i].monto
            }else{
              totalFinal+=this.movimientos[i].monto
              // this.dineroEfectivo+=this.movimientos[i].monto
            }

            // if(this.movimientos[i].forma_pago == '1'){
            //   if(this.movimientos[i].tipo == '0'){
            //     this.dineroEfectivo-=this.movimientos[i].total
            //   }else{
            //     this.dineroEfectivo+=this.movimientos[i].total
            //   }
            // }

            // if(this.movimientos[i].forma_pago == '2'){
            //   if(this.movimientos[i].tipo == '0'){
            //     this.dineroCuentaBanco-=this.movimientos[i].total
            //   }else{
            //     this.dineroCuentaBanco+=this.movimientos[i].total
            //   }
            // }

            // totalFinal = parseFloat(totalFinal)
            // totalFinal = totalFinal.toFixed(2)
            this.movimientosNuevos[i] = 
            {
              'id': this.movimientos[i].id,
              'fecha': this.movimientos[i].fecha,
              'sucursal': this.movimientos[i].sucursal,
              'fecha_pago': this.movimientos[i].fecha_pago,
              'concepto': this.movimientos[i].concepto,
              'tipo': this.movimientos[i].tipo,
              'monto': this.movimientos[i].monto,
              'forma_pago': this.movimientos[i].forma_pago,
              'totalFinal': totalFinal,
            };
           
          }
        }

      }, error => console.error(error))
  }

  agregarIngreso(){
    this.data = {
      'concepto': this.formulario.concepto,
      'total': this.formulario.total,
      'forma_pago': this.formulario.forma_pago,
      'inversion_inicial': '0',
    }

    // this._pagos.agregarIngreso(this.data).subscribe(
    //   data => {
    //     this.respuestaAgregar = data;
    //     if(this.respuestaAgregar.success){
    //       this.iziToast.show(
    //         {
    //             title: 'Se ha agregado el ingreso correctamente.',
    //             titleColor: '#f8f8ff',
    //             color: '#4CAF50',
    //             position: 'topRight',
    //             closeOnEscape: true,
    //         });
    //       this.formulario.concepto = '';
    //       this.formulario.total = 0;
    //       this.dismissAll();
    //       this.getFlujoEfectivo();
    //       window.location.reload();
    //     }else {
    //       alert('No se cargaron los datos');
    //     }
    //   }, error => console.error(error));
  }

  openModal(modal:any) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }


}
